/** @module components/Breadcrumb */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@devowl-wp/react-folder-tree";
const ICON_OBJ_SEP = /*#__PURE__*/ _jsx(Icon, {
    type: "right"
});
/**
 * Simple breadcrumbs with arrows and a home icon.
 *
 * @property {string[]} path The pathes
 * @type React.Element
 */ export default (({ path, closeable = false, onClose })=>{
    let i = 0; // Use counter as key
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                type: "folder"
            }),
            "\xa0\xa0",
            path.map((item)=>{
                return /*#__PURE__*/ _jsxs("span", {
                    children: [
                        item,
                        "\xa0",
                        i < path.length && ICON_OBJ_SEP,
                        "\xa0"
                    ]
                }, i++);
            }),
            !!closeable && /*#__PURE__*/ _jsx(Icon, {
                type: "close",
                onClick: onClose
            })
        ]
    });
});
